import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button } from '@mui/material';
import { Favorite, FavoriteBorder } from '@mui/icons-material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ProductCard from './ProductCard';
import { addLikeToProduct, setShowLikedProducts, getProducts } from '../../features/counterSlice';

const ProductsList = () => {
	const dispatch = useDispatch();
	const [shownProducts, setShownProducts] = useState(4);

	const products = useSelector(state => state.counter.products);
	const { likes, isShowLikedProducts } = useSelector(state => state.counter);

	const handleShowLikedProducts = () => {
		dispatch(setShowLikedProducts(!isShowLikedProducts))
	};

	const handleShowMoreProducts = () => {
		setShownProducts(shownProducts + 4)
	};

	useEffect(() => {
		dispatch(getProducts())
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div>
			<div className="w-full flex items-center justify-between lg:py-8 md:py-4 py-2 lg:px-32 md:px-16 px-8">
				<p className="lg:text-4xl md:text-xl text-sm font-bold">Content Title goes here</p>
				<div className="flex items-center space-x-4">
					{likes.length > 0 ? <Favorite style={{ color: "red" }} /> : <FavoriteBorder />}
					<p style={{ fontWeight: "bold" }} className="lg:text-base md:text-base text-sm">{likes.length + " ÜRÜN"}</p>
					<Button style={{
						"background": "#0059BC",
						"color": "white",
						textTransform: "none",
						padding: "0.5rem 1.5rem"
					}}
						onClick={handleShowLikedProducts}
						size="small"
					>
						{isShowLikedProducts ? "Hepsini göster" : "Beğenilenler"}</Button>
				</div>
			</div>
			<div className="grid flex gap-2 flex-wrap lg:grid-cols-4 md:grid-cols-4 grid-cols-1 justify-items-center">
				{!isShowLikedProducts ?
					(products.slice(0, shownProducts).map(product => (
						<ProductCard
							key={product.id}
							{...product}
							handleAddLike={() => {
								dispatch(addLikeToProduct(product))
							}}
						/>
					))) : (
						likes.map(product => (
							<ProductCard
								key={product.id}
								{...product}
								handleAddLike={() => {
									dispatch(addLikeToProduct(product))
								}}
							/>
						)))}
			</div>
			<div className="flex justify-center lg:pb-8 md:pb-4 pb-2">
				<Button size="large"
					style={{
						"background": "#0059BC",
						"color": "white",
						textTransform: "none"
					}}
					onClick={handleShowMoreProducts}>Daha Fazla
					<ArrowForwardIcon />
				</Button>
			</div>
		</div>
	);
};

export default ProductsList;